import { baseApi } from "app/baseApi";
import { baseQuery } from "app/baseQuery";
import { apiTags } from "app/store/apiTags";

const apiPrefix = 'LoadPricingConfig'

export const loadPricingApi = baseApi.injectEndpoints({
    reducerPath: 'LoadPricingConfigApi',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getAllLoadPricingConfigByClientId: builder.query({
            query: (clientId) => `${apiPrefix}?clientId=${clientId}`,
            transformResponse: (response) => {
                if (!Array.isArray(response)) return {};
                return response.reduce((acc, item) => {
                    acc[item.assetId] = item.ranges;
                    return acc;
                }, {});
            },
            providesTags: [apiTags.LOAD_PRICING_CONFIG]
        }),
        addLoadPricingConfig: builder.mutation({
            query: LoadPricingConfig => ({
                url: `${apiPrefix}`,
                method: "POST",
                body: LoadPricingConfig
            }),
            invalidatesTags: [apiTags.LOAD_PRICING_CONFIG]
        }),
        updateLoadPricingConfig: builder.mutation({
            query: LoadPricingConfig => ({
                url: `${apiPrefix}/update`,
                method: "PUT",
                body: LoadPricingConfig
            }),
            invalidatesTags: [apiTags.LOAD_PRICING_CONFIG]
        }),
        getPriceByParameters: builder.query({
            query: ({clientId, miles, assetClass, movementMethod }) => `${apiPrefix}/params?clientId=${clientId}&miles=${miles}&assetClass=${assetClass}&movementMethod=${movementMethod}`
        }),
        getPriceByAssetList: builder.query({
            query: ({ clientId, miles, assetClasses, movementMethod }) => {
                const params = new URLSearchParams({ clientId, miles, movementMethod });
                (assetClasses ?? []).forEach(ac => params.append('assetClasses', ac));
                return `${apiPrefix}/params/assets?${params.toString()}`;
            },
            providesTags: [apiTags.RUBRIC_PRICE_QUERY]
        }),
        calculateChargeFromCost: builder.query({
            query: ({clientId, cost}) => `${apiPrefix}/charge?clientId=${clientId}&cost=${cost}`
        })
    })
});

export const {
    useGetAllLoadPricingConfigByClientIdQuery,
    useAddLoadPricingConfigMutation,
    useUpdateLoadPricingConfigMutation,
    useGetPriceByParametersQuery,
    useGetPriceByAssetListQuery,
    useCalculateChargeFromCostQuery
} = loadPricingApi;